import { refreshTable } from '@packages/table-builder';
import { queryClient } from '@/queryClient';

export const SYSTEM_ROLES_TABLE_ENTITY = 'system-role';

/** V2 infinite-scroll table + legacy role list caches. */
export function refreshSystemRolesTable(registryRefresh?: () => void): void {
  registryRefresh?.();
  refreshTable(SYSTEM_ROLES_TABLE_ENTITY);
  void queryClient.invalidateQueries('dt-v2-page');
  void queryClient.invalidateQueries('getRoles');
}
